import React, { Component } from "react";
import { Link } from "react-router-dom";

// Import Images
import bg1 from "../../images/main-banner/bg1.jpg";
import doctorImg from "../../images/main-banner/hero.png";
import ptImg1 from "../../images/shap/trangle-orange.png";
import ptImg2 from "../../images/shap/square-blue.png";
import ptImg3 from "../../images/shap/chicle-blue-2.png";
import ptImg4 from "../../images/shap/plus-orange.png";
import ptImg5 from "../../images/shap/wave-orange.png";

class aboutSection extends Component {
  render() {
    return (
      <>
        <div
          className="main-banner"
          style={{ backgroundImage: "url(" + bg1 + ")" }}
        >
          <div className="container inner-content">
            <div className="row align-items-center">
              <div className="col-lg-7 col-md-6 col-sm-7">
                <h6 className="text-primary fw8">
                  Mind Care Clinic: Empowering Minds, Enriching Lives
                </h6>
                <h1>
                  Your Mental Health, <br /> Our Commitment
                </h1>
                <Link
                  to="/contact-us"
                  className="btn btn-primary btn-lg shadow"
                >
                  Begin Your Journey
                </Link>
              </div>
              <div className="col-lg-5 col-md-6 col-sm-5">
                <div className="banner-img">
                  <img
                    src={doctorImg}
                    alt="Dr. Partheeban"
                    className="hero_image"
                    loading="lazy"
                    // style={{ transform: "scaleX(-1)" }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <img className="pt-img1 animate1" src={ptImg3} alt="" />
          <img className="pt-img2 animate2" src={ptImg3} alt="" />
          <img className="pt-img3 animate3" src={ptImg2} alt="" />
          <img className="pt-img4 animate4" src={ptImg2} alt="" /> */}
          <img className="pt-img5 animate-wave" src={ptImg5} alt="" />
        </div>
      </>
    );
  }
}

export default aboutSection;
